import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { isBasicBridgeEnabledSelector } from '@cbridge-packages/auth';
import { AlertType, IAlertSubscription } from '@cbridge-packages/alert';
import { alertSubscriptionStoreSelector } from '../alertSubscription.selector';

/**
 * Alert subscriptions the UI may show: without the basicBridge feature only the connectivity alerts apply (LB-4724).
 * The Notification Service returns every type regardless of the tenant features.
 */
export const availableAlertSubscriptionsSelector = createCachedSelector(
  [
    path(alertSubscriptionStoreSelector).subscriptions(),
    isBasicBridgeEnabledSelector,
  ],
  (subscriptions, isBasicBridgeEnabled): IAlertSubscription[] => {
    const list = subscriptions ?? [];
    return isBasicBridgeEnabled ? list : list.filter((subscription) => subscription.type === AlertType.Connectivity);
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
